import React, {useState, useEffect, useRef} from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import {Icon} from "semantic-ui-react";
import {specificOrDefaultIdentifier} from "../common/commonUtilities";

export default function Device({deviceId, setDeviceId, handleDeviceChange}) {
  const [inputValue, setInputValue] = useState(deviceId === 'no_device' ? '' : deviceId);
  const [validated, setValidated] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const hasEditedRef = useRef(false);
  const target = useRef(null);

  const handleInputChange = (event) => {
    if (!hasEditedRef.current) {
      hasEditedRef.current = true;
    }
    setInputValue(event.target.value);
    const isInputValid = event.target.checkValidity();
    setShowPopover(!isInputValid);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      setShowPopover(true);
    } else {
      handleDeviceChange?.();
      hasEditedRef.current = false;
      setDeviceId(inputValue.toUpperCase());
      setValidated(false);
    }
  };

  useEffect(() => {
    if (deviceId === 'no_device') {
      if (!hasEditedRef.current) {
        setInputValue('');
      }
    } else {
      setInputValue(deviceId);
      hasEditedRef.current = false;
    }
  }, [deviceId]);

  useEffect(() => {
    const input = document.getElementById("device-id");
    if (input) {
      const isInputValid = input.checkValidity();
      setShowPopover(!isInputValid && input.value !== '');
    }
  }, [deviceId]);

  return (
    <Form noValidate onSubmit={handleSubmit} className={validated ? "was-validated" : ""}>
      <Form.Label>{specificOrDefaultIdentifier(document.getElementById("device-id") ? document.getElementById("device-id").value.toUpperCase() : "")}</Form.Label>
      <InputGroup>
        <Form.Control
          ref={target}
          type="text"
          name="device-id"
          id="device-id"
          required
          onInput={handleInputChange}
          value={inputValue}
          maxLength="23"
          size="23"
          pattern="^(?!70-[Bb]3-[Dd]5-1[Ff]-3)[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}|^\d{1,10}$|^\d{13}$"
          placeholder="Enter Device ID or MPxN"
          title="Enter Device ID or MPxN"
        />
        <Overlay
          show={showPopover}
          target={target.current}
          placement="right"
          containerPadding={20}>
          <Popover id="popover-invalid-feedback">
            <Popover.Body>
              Please enter:
              <ul>
                <li>a non DCC-reserved device ID GUID in the format Aa-22-33-44-55-66-77-88 using a-f, A-F and 0-9</li>
                <li>a valid 13 digit MPAN</li>
                <li>a valid 1-10 digit MPRN</li>
              </ul>
            </Popover.Body>
          </Popover>
        </Overlay>
        <div className="d-grid">
          <Button type="submit">
            <Icon name="sync alternate" />
          </Button>
        </div>
      </InputGroup>
    </Form>
  );
}
